import { create } from 'zustand';
import type { PortalPublicInfo } from '@webmail/shared';
import { portalApi } from '../lib/api';

// Branding neutro di default: nessun cliente cablato nel codice.
// Titolo e accent arrivano dalla config del portale (PORTAL_BRAND_TITLE / PORTAL_BRAND_ACCENT).
const DEFAULT_TITLE = 'AI Webmail';
const DEFAULT_ACCENT = '#38BDF8';

const FALLBACK: PortalPublicInfo = {
  hostname: '',
  mode: 'shared',
  brand: '',
  aiFeaturesEnabled: true,
};

interface PortalState {
  portal: PortalPublicInfo;
  brandTitle: string;
  loaded: boolean;
  init: () => Promise<void>;
}

function applyBranding(portal: PortalPublicInfo): string {
  const title = portal.brandTitle?.trim() || DEFAULT_TITLE;
  const accent = portal.brandAccent?.trim() || DEFAULT_ACCENT;
  document.title = title;
  document.documentElement.style.setProperty('--portal-accent', accent);
  return title;
}

export const usePortal = create<PortalState>((set) => ({
  portal: FALLBACK,
  brandTitle: DEFAULT_TITLE,
  loaded: false,

  init: async () => {
    let portal = FALLBACK;
    try {
      portal = (await portalApi.get()) as PortalPublicInfo;
    } catch {
      // Fetch fallito: branding neutro di default
    }
    set({ portal, brandTitle: applyBranding(portal), loaded: true });
  },
}));
